import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Expand, RotateRight } from "@mui/icons-material";
import React from "react";

type IntervalProps = {
  isRegular?: boolean;
  paymentInterval?: number;
  isInterAccountTransfer?: boolean;
  isAdjustingEntry?: boolean;
};
export const IntervalInfo = ({
  isRegular,
  paymentInterval,
  isInterAccountTransfer,
  isAdjustingEntry,
}: IntervalProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isDownSm = useMediaQuery(theme.breakpoints.down("sm"));
  const mapIntervalToApi: Record<number, string> = {
    1: "everyMonth",
    2: "biMonthly",
    3: "quarterly",
    6: "biAnnual",
    12: "annual",
  };

  return (
    <Box display={isDownSm ? "flex" : "column"} mt={1}>
      {isRegular && (
        <Box display="flex" alignItems="center" mr={3} width="max-content">
          <RotateRight
            sx={{
              width: "16px",
              height: "16px",
              marginRight: 1,
              color: theme.palette.icon.secondary,
            }}
          />
          {paymentInterval ? (
            <Typography variant="body3" color="textSecondary">
              {t(
                `singleAccountPage.protocolTable.interval.${mapIntervalToApi[paymentInterval]}`
              )}
            </Typography>
          ) : (
            <Typography variant="body3" color="textSecondary">
              {t(`cashflowAnalyzer.transactionsTable.regular`)}
            </Typography>
          )}
        </Box>
      )}
      {isInterAccountTransfer && (
        <Box display="flex" alignItems="center">
          <Expand
            sx={{
              width: "16px",
              height: "16px",
              transform: "rotate(90deg)",
              marginRight: 1,
              color: theme.palette.icon.secondary,
            }}
          />
          <Typography variant="body3" color="textSecondary">
            {t("singleAccountPage.protocolTable.transfer")}
          </Typography>
        </Box>
      )}
      {isAdjustingEntry && (
        <Typography variant="body3" color="textSecondary">
          {t("singleAccountPage.protocolTable.adjustingEntry")}
        </Typography>
      )}
    </Box>
  );
};
